import { render, staticRenderFns } from "./StudentLayout.vue?vue&type=template&id=e214c182&scoped=true"
import script from "./StudentLayout.vue?vue&type=script&lang=js"
export * from "./StudentLayout.vue?vue&type=script&lang=js"
import style0 from "./StudentLayout.vue?vue&type=style&index=0&id=e214c182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e214c182",
  null
  
)

export default component.exports